import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import styles from './hero.module.scss';

const propTypes = {
  className: PropTypes.string
};

const HeroBanner = ({className = null}) => (
  <div className={styles['overflow-x']}>
    <Container>
      <Grid>
        <Row>
          <Col xs={12} className={styles['hero-holder']}>
            <div className={className} />
          </Col>
        </Row>
      </Grid>
    </Container>
  </div>
);

HeroBanner.propTypes = propTypes;

export default HeroBanner;
